export default __webpack_public_path__ + "static/media/mq.794f4690.svg";